var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"career-title"},[_vm._t("default"),_c('add-button',{on:{"add":function($event){return _vm.add()}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }